import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { PorangeButton } from "@/components/atoms/PorangeButton";
import confetti from 'canvas-confetti';
import classNames from 'classnames';

// Separated animation variants
const animations = {
    container: {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
        exit: { opacity: 0, y: 20 }
    },
    title: {
        hidden: { opacity: 0, y: 30 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    }
};

// Separated confetti configuration
const confettiConfig = {
    particleCount: 150,
    spread: 100,
    origin: { y: 0.6 },
    colors: ['#FF9B73', '#FFB17A', '#FFC681'],
    gravity: 0.8,
};

// Separated Title component for better organization
const Title = ({ showTitle }) => (
    <div className="text-center space-y-4 max-w-[600px] mt-[48px] mb-8">
        <motion.h1 
            variants={animations.title}
            initial="hidden"
            animate={showTitle ? "visible" : "hidden"}
            className="text-[32px] md:text-[40px] leading-tight font-bold text-black"
        >
            Our gluten-free map is{' '}
            <span className="relative inline-block">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-pink-500 via-orange-500 to-pink-500">
                    perfect for you!
                </span>
                <motion.span 
                    className="absolute bottom-0 left-0 w-full h-[4px] bg-gradient-to-r from-pink-500 via-orange-500 to-pink-500 rounded-full"
                    initial={{ scaleX: 0 }}
                    animate={{ scaleX: showTitle ? 1 : 0 }}
                    transition={{ delay: 0.5, duration: 0.8 }}
                />
            </span>
        </motion.h1>
    </div>
);

export const Statement = ({ onAnswer }) => {
    const [showTitle, setShowTitle] = useState(false);
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        confetti(confettiConfig);

        const timers = [
            setTimeout(() => setShowTitle(true), 100),
            setTimeout(() => {
                setIsExiting(true);
                setTimeout(() => onAnswer('continue'), 800);
            }, 2500)
        ];

        return () => timers.forEach(timer => clearTimeout(timer));
    }, []);

    return (
        <motion.div 
            initial="hidden"
            animate={isExiting ? "exit" : "visible"}
            variants={animations.container}
            className="relative h-full flex flex-col items-center justify-start px-6"
        >
            <Title showTitle={showTitle} />
        </motion.div>
    );
};

export default Statement; 